{
  "possibleTypes": {
    "ActivateEntraUserResponse": [
      "AlreadyLinked",
      "InvalidOid",
      "UserWithLoginData"
    ],
    "ActivateSsoLoginResponse": [
      "AlreadyLinked",
      "InvalidEntraToken",
      "InvalidOid",
      "SsoLoginData"
    ],
    "CreatePasswordLoginResponse": [
      "AlreadyHasPasswordLogin",
      "EmailTaken",
      "Success"
    ],
    "CreateUserWithPasswordLoginResponse": [
      "CreatedUser",
      "EmailTaken"
    ],
    "DeactivatePasswordLoginResponse": [
      "NotFound",
      "Success"
    ],
    "DeactivateSsoLoginResponse": [
      "NotFound",
      "Success"
    ],
    "LoginResponse": [
      "InvalidCredentials",
      "Session"
    ],
    "RefreshJwtResponse": [
      "Session"
    ],
    "SetPasswordResponse": [
      "Success"
    ],
    "UpdatePasswordResponse": [
      "InvalidCredentials",
      "Success"
    ]
  }
}